// Inline SVG icons for /app (no emoji, no icon library). Paths from _v2/design/Main.dc.html.
import React from 'react';

function Svg({ size = 20, stroke = 'currentColor', width = 1.8, children, ...rest }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={stroke}
      strokeWidth={width} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" {...rest}>
      {children}
    </svg>
  );
}

export const IconLeaf = (p) => (
  <Svg size={18} {...p}><path d="M5 19c0-9 5-14 15-14 0 10-5 15-14 15" /><path d="M5 19c3-5 6-8 10-10" /></Svg>
);
export const IconHome = (p) => (
  <Svg {...p}><path d="M3 11l9-8 9 8v9a1 1 0 0 1-1 1h-5v-6H9v6H4a1 1 0 0 1-1-1z" /></Svg>
);
export const IconNotes = (p) => (
  <Svg {...p}><path d="M4 5a2 2 0 0 1 2-2h13v16H6a2 2 0 0 0-2 2z" /><path d="M8 8h7M8 12h7" /></Svg>
);
export const IconTarget = (p) => (
  <Svg {...p}><circle cx="12" cy="12" r="9" /><circle cx="12" cy="12" r="5" /><circle cx="12" cy="12" r="1" /></Svg>
);
export const IconChecklist = (p) => (
  <Svg {...p}><path d="M10 6h10M10 12h10M10 18h10M4 6l1 1 2-2M4 12l1 1 2-2M4 18l1 1 2-2" /></Svg>
);
export const IconBolt = (p) => (
  <Svg {...p}><path d="M13 3L5 14h6l-1 7 8-11h-6z" /></Svg>
);
export const IconSearch = (p) => (
  <Svg {...p}><circle cx="11" cy="11" r="7" /><path d="M20 20l-4-4" /></Svg>
);
export const IconCheck = (p) => (
  <Svg size={16} width={2} {...p}><path d="M5 12l5 5 9-10" /></Svg>
);
export const IconChevronRight = (p) => (
  <Svg size={18} width={2} {...p}><path d="M9 5l7 7-7 7" /></Svg>
);
export const IconArrowLeft = (p) => (
  <Svg size={18} width={2} {...p}><path d="M15 5l-7 7 7 7" /></Svg>
);
// Tests (C7.4) — paths from _v2/design/Question.dc.html
export const IconClock = (p) => (
  <Svg size={18} width={2} {...p}><circle cx="12" cy="13" r="8" /><path d="M12 9v4l3 2M9 2h6" /></Svg>
);
export const IconWrong = (p) => (
  <Svg size={16} width={2.4} {...p}><path d="M6 6l12 12M18 6L6 18" /></Svg>
);
export const IconRight = (p) => (
  <Svg size={16} width={2.4} {...p}><path d="M5 12l5 5 9-10" /></Svg>
);
export const IconBook = (p) => (
  <Svg size={18} {...p}><path d="M4 5a2 2 0 0 1 2-2h13v16H6a2 2 0 0 0-2 2z" /><path d="M8 8h7M8 12h7" /></Svg>
);
export const IconArrowRight = (p) => (
  <Svg size={16} width={2} {...p}><path d="M5 12h14M13 6l6 6-6 6" /></Svg>
);

export const IconOpen = (p) => (
  <Svg size={16} {...p}><path d="M7 17L17 7M9 7h8v8" /></Svg>
);
// Refresh (desktop title bar, 2026-10-31): a circular arrow.
export const IconRefresh = (p) => (
  <Svg size={16} {...p}><path d="M20 12a8 8 0 1 1-2.34-5.66" /><path d="M20 4v5h-5" /></Svg>
);
export const IconMinimize = () => (
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" stroke="currentColor" strokeWidth="1.2" aria-hidden="true"><path d="M2 6h8" /></svg>
);
export const IconMaximize = () => (
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" stroke="currentColor" strokeWidth="1.2" aria-hidden="true"><rect x="2.5" y="2.5" width="7" height="7" /></svg>
);
export const IconClose = () => (
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" stroke="currentColor" strokeWidth="1.2" aria-hidden="true"><path d="M2.5 2.5l7 7M9.5 2.5l-7 7" /></svg>
);
// C12.1 (D-106): the two kinds of section video.
export const IconPlayCircle = (p) => (
  <Svg {...p}><circle cx="12" cy="12" r="9.2" /><path d="M10 8.6l5.4 3.4-5.4 3.4z" fill="currentColor" stroke="none" /></Svg>
);
export const IconQuestionCircle = (p) => (
  <Svg {...p}><circle cx="12" cy="12" r="9.2" /><path d="M9.6 9.3a2.5 2.5 0 0 1 4.85.85c0 1.7-2.45 2.2-2.45 3.65" /><circle cx="12" cy="16.9" r="0.6" fill="currentColor" /></Svg>
);
